module.exports = __webpack_public_path__ + "static/media/dubai.f832b85a.gif";